export const tracks = [
  {
    title: 'Rock BGM',
    type: 'Original production',
    audioUrl: '',
    soundcloudUrl: 'https://soundcloud.com/k-beats-291187445/rock-bgm',
    embedUrl: 'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/soundcloud%253Atracks%253A2388433902&color=%23ccff00&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false',
  },
  {
    title: 'Gaming BGM Sample',
    type: 'Original production',
    audioUrl: '',
    soundcloudUrl: 'https://soundcloud.com/k-beats-291187445/gaming-bgm-sample',
    embedUrl: 'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/soundcloud%253Atracks%253A2388433614&color=%23ccff00&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false',
  },
  {
    title: 'Sitarmix',
    type: 'Original production',
    audioUrl: '',
    soundcloudUrl: 'https://soundcloud.com/k-beats-291187445/sitarmix',
    embedHeight: 300,
    embedUrl: 'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/soundcloud%253Atracks%253A2388433026&color=%23ccff00&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false&visual=true',
  },
  {
    title: 'Background music KB101',
    type: 'Original production',
    audioUrl: '',
    soundcloudUrl: 'https://soundcloud.com/k-beats-291187445/background-music-kb101',
    embedHeight: 300,
    embedUrl: 'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/soundcloud%253Atracks%253A2388432633&color=%23ccff00&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false&visual=true',
  },
  {
    title: 'Cinematics',
    type: 'Original production playlist',
    audioUrl: '',
    soundcloudUrl: 'https://soundcloud.com/k-beats-291187445/sets/cinematics',
    embedHeight: 300,
    embedUrl: 'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/soundcloud%253Aplaylists%253A2283412515&color=%23ccff00&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false&visual=true',
  },
  {
    title: 'K Beats House Mix 11125',
    type: 'Original production',
    audioUrl: '',
    soundcloudUrl: 'https://soundcloud.com/k-beats-291187445/k-beats-house-mix-11125',
    embedHeight: 300,
    embedUrl: 'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/soundcloud%253Atracks%253A2204056799&color=%23ccff00&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false&visual=true',
  },
  {
    title: 'Kbeats House Mix',
    type: 'Original production',
    audioUrl: '',
    soundcloudUrl: 'https://soundcloud.com/k-beats-291187445/kbeats_house_mix',
    embedHeight: 300,
    embedUrl: 'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/soundcloud%253Atracks%253A2185077247&color=%23ccff00&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false&visual=true',
  },
];

